const style = {
  capsule: {
    width: '100%',
    isolation: 'isolate',
    position: 'relative',
  },
  upsideCapsule: {
    display: 'flex',
    flexDirection: 'column-reverse',
  },
  header: {
    borderRadius: '12px 12px 0 0',
    backgroundColor: '#924833',
    height: '4px',
    position: 'static',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1,
  },
  upsideHeader: {
    borderRadius: '0 0 12px 12px',
  },
  headerLarge: {
    backgroundColor: '#1E2643',
    height: '48px',
    position: 'relative',
  },
  headerAuto: {
    backgroundColor: '#1E2643',
    position: 'relative',
    padding: '10px',
    height: 'auto',
  },
  content: {
    position: 'relative',
    borderRadius: '0 0 12px 12px',
    backgroundColor: '#fff',
    overflow: 'hidden',
    border: 'solid 1px #d1d1d1',
  },
  upsideContent: {
    marginTop: '-1px',
    borderRadius: '12px 12px 0 0',
  },
  contentNoHeader: {
    marginTop: '-1px',
    borderRadius: '12px',
  },
  contentLargeHeader: {
    paddingTop: '34px',
    marginTop: '-35px',
  },
  upsideContentLargeHeader: {
    paddingTop: '0',
    marginTop: '0',
    paddingBottom: '34px',
    marginBottom: '-35px',
  },
  label: {
    fontFamily: 'Trident, Newsreader, Times New Roman, Times, serif',
    verticalAlign: '-3px',
  },
  checkIcon: {
    position: 'absolute',
    display: 'flex',
    top: '-12px',
    right: '-9px',
    left: '-9px',
    justifyContent: 'flex-end',
  },
};

export const styles = ({
  additionalStyle = {
    header: {},
    content: {},
    icon: {},
    label: {},
  },
  color,
  isHeaderNone,
  isLargeHeader,
  isHeaderAuto,
  upside,
}) => ({
  computedCapsuleStyle: {
    ...style.capsule,
    ...(upside ? style.upsideCapsule : null),
    ...additionalStyle.root,
  },
  computedHeaderStyle: {
    ...style.header,
    ...(isLargeHeader ? style.headerLarge : null),
    ...(isHeaderAuto ? style.headerAuto : null),
    ...(upside ? style.upsideHeader : null),
    ...(color ? { backgroundColor: color } : null),
    ...additionalStyle.header,
  },

  computedHeaderFullStyle: {
    ...style.header,
    justifyContent: 'space-between',
    paddingLeft: '20px',
    paddingRight: '20px',
    cursor: 'pointer',
    ...(isLargeHeader ? style.headerLarge : null),
    ...(isHeaderAuto ? style.headerAuto : null),
    ...(upside ? style.upsideHeader : null),
    ...(color ? { backgroundColor: color } : null),
    ...additionalStyle.header,
  },
  computedHeaderFullStyleCollapsed: {
    ...style.header,
    justifyContent: 'space-between',
    paddingLeft: '20px',
    paddingRight: '20px',
    cursor: 'pointer',
    ...(isLargeHeader ? style.headerLarge : null),
    ...(isHeaderAuto ? style.headerAuto : null),
    ...(upside ? style.upsideHeader : null),
    ...(color ? { backgroundColor: color } : null),
    ...additionalStyle.header,
    borderRadius: '5px',
  },
  computedContentStyle: {
    ...style.content,
    ...(upside ? style.upsideContent : null),
    ...(isLargeHeader ? style.contentLargeHeader : null),
    ...(isLargeHeader && upside ? style.upsideContentLargeHeader : null),
    ...(isHeaderNone ? style.contentNoHeader : null),
    ...additionalStyle.content,
  },

  computedIconWrapperStyle: {
    ...additionalStyle.icon,
  },

  computedLabelStyle: {
    ...style.label,
    ...additionalStyle.label,
    marginLeft: '10px',
  },

  computedCheckIconStyle: {
    ...style.checkIcon,
  },
  computedChevronIconlStyle: {
    display: 'flex',
    width: '9px',
    height: '9px',
    stroke: 'white',
    strokeWidth: '2px',
    alignItems: 'center',
    marginTop: '-3px',
  },
});
